<template>
  <div>
    <vg-heading>申请进度</vg-heading>
    <vg-card class="padding">
      <vg-text-track :value="value"/>
    </vg-card>
  </div>
</template>

<script>
import VgCard from "@/components/Commons/VgCard";
import VgHeading from "@/components/Html/VgHeading";
import VgTextTrack from "@/components/Commons/VgTextTrack";

export default {
  name: "ApplicationProgress",
  components: {VgTextTrack, VgHeading, VgCard},
  props: {
    value: Array
  }
}
</script>

<style scoped>

</style>